import { render, staticRenderFns } from "./ProductCodeTypeList.vue?vue&type=template&id=677ef0c3&"
import script from "./ProductCodeTypeList.vue?vue&type=script&lang=js&"
export * from "./ProductCodeTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports